/* External Imports */
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import { Box, Image, Text } from '@chakra-ui/react';

import { IoIosArrowForward } from 'react-icons/io';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const OurOfferings = ({ sectionContent, region, language }) => {
  const cardData = [
    {
      type: 'square',
      widthBase: '90%',
      widthMd: 390,
      heightBase: '220px',
      heightMd: '354px',
      marginTopBase: '6%',
      marginTopMd: '80px',
    },
    {
      type: 'rectangle',
      widthBase: '90%',
      widthMd: '300px',
      heightBase: '304px',
      heightMd: '488px',
    },
    {
      type: 'square',
      widthBase: '90%',
      widthMd: 420,
      heightBase: '220px',
      heightMd: '406px',
      marginTopBase: '6%',
      marginTopMd: '48px',
    },
    {
      type: 'rectangle',
      widthBase: '90%',
      widthMd: '315px',
      heightBase: '304px',
      heightMd: '502px',
    },
  ];

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        bottom="-100px"
        right={{ lg: '45.5%', xl: '46.5%' }}
        zIndex={1000}
        bgColor="#EDA807"
        // width="6rem"
        // height="3rem"
        bgPosition="center"
        borderRadius="0px 16px 16px 0px"
        bgSize="cover"
        boxSize="2.5rem"
        overflow="visible" /* Change overflow to visible temporarily */
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        justifyContent="center"
        color="#FEFAF6"
        _hover={{
          bgColor: 'rgba(237, 168, 7, 0.4)',
        }}
        cursor="pointer"
        padding="0"
      >
        <ChevronRightIcon fontSize="2rem" />
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        borderRadius="16px 0px 0px 16px"
        bottom="-100px"
        bgPosition="center"
        bgSize="cover"
        right={{ md: '50%', '2xl': '49%' }}
        zIndex={1000}
        // width="5rem"
        // height="3rem"
        _hover={{
          bgColor: 'rgba(237, 168, 7, 0.4)',
        }}
        bgColor="#EDA807"
        boxSize="2.5rem"
        overflow="visible" /* Change overflow to visible temporarily */
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        fontSize="1rem"
        padding="0"
        color="#FEFAF6"
      >
        <ChevronLeftIcon fontSize="2rem" />{' '}
      </Box>
    );
  };

  // const settings = {
  //   dots: true,
  //   className: 'center',
  //   adaptiveHeight: false,
  //   infinite: true,
  //   speed: 1000,
  //   nextArrow: <NextArrow />, // Custom next arrow
  //   prevArrow: <PrevArrow />,
  //   arrows: true,
  //   swipe: true, // Enable swipe functionality
  //   swipeToSlide: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 3,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 2,
  //         arrows: true,
  //       },
  //     },
  //     {
  //       breakpoint: 800,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  const settings = {
    className: 'slider variable-width',
    dots: true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    variableWidth: true,
  };
  const { simpleCards } = sectionContent[1];

  return (
    <Box
      width="100%"
      // border="2px solid red"
      marginTop="0"
      // paddingX={30}
      // maxHeight={{ lg: '700', base: '430', md: '700' }}
      position="relative"
      overflow="hidden"
      pb={{ base: '15%', '2xl': '10%' }}
      _before={{
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'black',
        clipPath: 'polygon(0 44%, 100% 63%, 100% 100%, 0% 100%)',
        // clipPath: 'polygon(0 44%, 100% 63%, 100% 100%, 0% 100%)',
        zIndex: 1,
      }}
    >
      <Box
        display={{ base: 'flex' }}
        color={{ base: '#010509' }}
        alignItems={{ base: 'center' }}
        marginLeft={{ md: '5%', lg: '8rem' }}
        justifyContent={{ base: 'center', md: 'flex-start' }}
        gap="4px"
        fontSize={{ base: '1.5rem', md: '2.25rem' }}
        fontFamily="var(--FedraSerifDisplay-light)"
        position="relative"
        zIndex={2}
      >
        <Text
          fontWeight="normal"
          fontFamily={'var(--FedraSerifDisplay-Regular)'}
        >
          {sectionContent[0]?.titleText}
        </Text>
        <Text fontWeight="extrabold">{sectionContent[0]?.titleSubtext}</Text>
      </Box>

      <Box
        className="slider-container"
        marginTop={{ base: '16px', md: '32px' }}
        css={{
          '.slick-slide': {
            margin: '0 10px !important',
          },
          '.slick-list': {
            margin: '0 -10px !important',
          },
        }}
        position="relative"
        zIndex={2}
      >
        <Slider {...settings}>
          {simpleCards.map((card, index) => (
            <Box
              key={index}
              width={{
                base: cardData[index % cardData.length].widthBase,
                md: cardData[index % cardData.length].widthMd,
              }}
              height={{
                base: cardData[index % cardData.length].heightBase,
                md: cardData[index % cardData.length].heightMd,
              }}
              // width={300}
              // height={300}
              objectFit="fill"
              position="relative"
              marginTop={
                cardData[index % cardData.length].type === 'square'
                  ? {
                      base: cardData[index % cardData.length].marginTopBase,
                      md: cardData[index % cardData.length].marginTopMd,
                    }
                  : undefined
              }
            >
              <Image
                src={card.rectangularImage.url}
                alt={card.rectangularImage.alt || 'no image found'}
                layout="fill"
                objectFit="cover"
                width="100%"
                height="100%"
              />
              <Link
                href={refineUrlDomain(card.linkUrl, region, language)}
                prefetch
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  py={{ base: '.5rem', md: '1rem' }}
                  px={{ base: '1rem', md: '2rem' }}
                  letterSpacing="2%"
                  position="absolute"
                  bottom="0px"
                  left="0"
                  right="0"
                  bg="linear-gradient(rgba(255, 255, 255, 0.7), rgba(153, 153, 153, 0.7))"
                >
                  <Box>
                    <Text
                      fontSize={{ base: '0.75rem', md: '1rem' }}
                      fontFamily="var(--FedraSansStd-book)"
                      lineHeight="160%"
                    >
                      {card.title}
                    </Text>
                    <Text
                      fontSize={{ base: '1.25rem', md: '1.75rem' }}
                      fontWeight="medium"
                      fontFamily="var(--FedraSansStd-medium)"
                    >
                      {card.descriptionText}
                    </Text>
                  </Box>
                  <Box
                    w="50px"
                    h="30px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Link
                      href={refineUrlDomain(card.linkUrl, region, language)}
                      prefetch
                    >
                      <IoIosArrowForward
                        style={{ width: '50px', height: '30px' }}
                      />
                    </Link>
                  </Box>
                </Box>
              </Link>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default OurOfferings;
